import React from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  useMediaQuery,
  Box,
  Card,
  CardContent,
} from '@mui/material'
import { IMAGE_BASE_PATH_COMMON } from '../../Config/Config'

const WorkingCommittee = () => {
  const isMobile = useMediaQuery('(max-width: 768px)')

  const workingCommittee = [
    {
      Sno: 1,
      id: 1,
      name: 'Dr. D. SRUJANA',
      designation: 'CHAIRPERSON',
      image_url:
        'https://dbraeiassetmanagement.blob.core.windows.net/dbraei-dev/dbralc/IQAC/Wroking committee/Dr D. SRUJANA.jpg',
    },
    {
      Sno: 2,
      id: 2,
      name: 'Mr. P. V. RAMANA KUMAR',
      designation: 'MANAGEMENT MEMBER',
      image_url:
        'https://dbraeiassetmanagement.blob.core.windows.net/dbraei-dev/dbralc/IQAC/Wroking committee/Mr. P.V.RAMANA KUMAR.jpg',
    },
    {
      Sno: 3,
      id: 3,
      name: 'Dr. J. E. PADMAJA',
      designation: 'IQAC CO-ORDINATOR',
      image_url:
        'https://dbraeiassetmanagement.blob.core.windows.net/dbraei-dev/dbralc/IQAC/Wroking committee/Dr. J.E.PADMAJA.jpg',
    },
    {
      Sno: 4,
      id: 4,
      name: 'Mr. J. VASANTH KUMAR',
      designation: 'FACULTY MEMBER',
      image_url:
        'https://dbraeiassetmanagement.blob.core.windows.net/dbraei-dev/dbralc/IQAC/Wroking committee/Mr. J.VASANTH KUMAR.jpg',
    },
    {
      Sno: 5,
      id: 5,
      name: 'Ms. S. P. NALINI',
      designation: 'FACULTY MEMBER',
      image_url:
        'https://dbraeiassetmanagement.blob.core.windows.net/dbraei-dev/dbralc/IQAC/Wroking committee/Ms. S. P. NALINI.jpg',
    },
    {
      Sno: 6,
      id: 6,
      name: 'Dr. M. SRIDEVI',
      designation: 'FACULTY MEMBER',
      image_url:
        'https://dbraeiassetmanagement.blob.core.windows.net/dbraei-dev/dbralc/IQAC/Wroking committee/Dr M. SRIDEVI.jpg',
    },
    {
      Sno: 7,
      id: 7,
      name: 'Dr. B. SOMESHWAR',
      designation: 'FACULTY MEMBER',
      image_url:
        'https://dbraeiassetmanagement.blob.core.windows.net/dbraei-dev/dbralc/IQAC/Wroking committee/Dr B. SOMESHWAR.jpg',
    },
    {
      Sno: 8,
      id: 8,
      name: 'Mr. N. KIRAN KUMAR',
      designation: 'ADMINISTRATIVE OFFICER',
      image_url:
        'https://dbraeiassetmanagement.blob.core.windows.net/dbraei-dev/dbralc/IQAC/Wroking committee/Mr. N.KIRAN KUMAR.jpg',
    },
    {
      Sno: 9,
      id: 9,
      name: 'Mr. RAJ KHANNA',
      designation: 'STAKE HOLDERS',
      image_url:
        'https://dbraeiassetmanagement.blob.core.windows.net/dbraei-dev/dbralc/IQAC/Wroking committee/Mr.RAJ KHANNA.jpg',
    },
    {
      Sno: 10,
      id: 10,
      name: 'Mr. CH. NARESH KUMAR',
      designation: 'STAKE HOLDERS',
      image_url:
        'https://dbraeiassetmanagement.blob.core.windows.net/dbraei-dev/dbralc/IQAC/Wroking committee/Mr.CH. NARESH KUMAR.jpg',
    },
    {
      Sno: 11,
      id: 11,
      name: 'Dr. Y. S. KIRAN KUMAR',
      designation: 'LOCAL SOCIETY MEMBER',
      image_url:
        'https://dbraeiassetmanagement.blob.core.windows.net/dbraei-dev/dbralc/IQAC/Wroking committee/Dr Y. S. KIRAN KUMAR.jpg',
    },
    {
      Sno: 12,
      id: 12,
      name: 'Dr. BANDARI',
      designation: 'LOCAL SOCIETY MEMBER',
      image_url:
        'https://dbraeiassetmanagement.blob.core.windows.net/dbraei-dev/dbralc/IQAC/Wroking committee/Dr BANDARI.jpg',
    },
  ]

  return (
    <section className="container py-4">
      <Typography
        variant="h5"
        sx={{ my: 2, textAlign: 'center', fontWeight: 'bold' }}
      >
        WORKING COMMITTEE
      </Typography>

      {isMobile ? (
        <Box>
          {workingCommittee.map((row, index) => (
            <Card
              key={index}
              sx={{
                mb: 2,
                p: 2,
                display: 'flex',
                alignItems: 'center',
                gap: 2,
              }}
            >
              <img
                src={
                  row.image_url ||
                  `${IMAGE_BASE_PATH_COMMON}Placeholders/Placeholder_Image.jpg`
                }
                alt={row.name}
                loading="lazy"
                placeholder="blur"
                style={{
                  borderRadius: '10px',
                  objectFit: 'cover',
                  width: '80px',
                  height: '80px',
                  boxShadow: '4px 0px 5px rgba(0, 0, 0, 0.3)',
                }}
              />
              <CardContent>
                <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                  {row.name}
                </Typography>
                <Typography variant="body2">{row.designation}</Typography>
              </CardContent>
            </Card>
          ))}
        </Box>
      ) : (
        <TableContainer component={Paper} sx={{ overflowX: 'auto' }}>
          <Table sx={{ minWidth: 600 }}>
            <TableHead>
              <TableRow sx={{ backgroundColor: '#494798' }}>
                <TableCell sx={{ fontWeight: 'bold', color: 'white' }}>
                  S.NO
                </TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: 'white' }}>
                  Name of the Member
                </TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: 'white' }}>
                  Designation
                </TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: 'white' }}>
                  Image
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {workingCommittee.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{ '&:nth-of-type(even)': { backgroundColor: '#f5f5f5' } }}
                >
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{row.name}</TableCell>
                  <TableCell>{row.designation}</TableCell>
                  <TableCell>
                    <img
                      src={
                        row.image_url ||
                        `${IMAGE_BASE_PATH_COMMON}Placeholders/Placeholder_Image.jpg`
                      }
                      alt={row.name}
                      loading="lazy"
                      placeholder="blur"
                      style={{
                        borderRadius: '10px',
                        objectFit: 'fill',
                        width: '100px',
                        height: '100px',
                        boxShadow: '4px 0px 5px rgba(0, 0, 0, 0.3)',
                      }}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </section>
  )
}

export default WorkingCommittee
